<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";

export default {
    name: "WEnumSelect",
    props: {
        value: [Number, String, Boolean, Object, Array],
        rules: Array,
        label: String,
        itemValue: String,
        itemText: String,
        loading: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        multiple: Boolean,
        notClearable: Boolean,
        returnObject: Boolean,
        items: Array,
        prependIcon: String,
        prependInnerIcon: String,
        appendIcon: String,
        appendOuterIcon: String,
    },
    emits: ["click", "change", "prependClick", "prependInnerClick", "appendClick", "appendOuterClick"],
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const item = ref(null);

        watch(() => props.value, () => {
            item.value = props.value;
        });

        onMounted(() => {
            if (props.value !== null && props.value !== undefined)
                item.value = props.value;
        });

        function input(value) {
            emit("input", value);
        }

        function click() {
            emit("click");
        }

        function change() {
            emit("change");
        }
        
        function prependClick() {
            emit("prependClick");
        }
        
        function prependInnerClick() {
            emit("prependInnerClick");
        }
        
        function appendClick() {
            emit("appendClick");
        }
        
        function appendOuterClick() {
            emit("appendOuterClick");
        }

        return {
            loading,
            inputColor,
            backgroundColor,
            item,
            input,
            click,
            change,
            prependClick,
            prependInnerClick,
            appendClick,
            appendOuterClick,
        };
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="item"
            :label="label"
            :items="items"
            :item-value="itemValue || 'id'"
            :item-text="itemText || 'name'"
            outlined
            dense
            :prepend-icon="prependIcon"
            :prepend-inner-icon="prependInnerIcon"
            :append-icon="appendIcon"
            :append-outer-icon="appendOuterIcon"
            :disabled="disabled"
            :loading="loading"
            :return-object="returnObject"
            :multiple="multiple"
            :readonly="readonly"
            :chips="multiple"
            :deletable-chips="multiple && !readonly"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="input"
            @change="change"
            @click="click"
            @click:prepend="prependClick"
            @click:prepend-inner="prependInnerClick"
            @click:append="appendClick"
            @click:append-outer="appendOuterClick"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>

<style scoped></style>